import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import { EMPTY_ARRAY } from 'commons-ui';

import { HasPermissionArgument } from 'routes/usePermission';
import { EAbExpActions } from '../utils/constants';

type ABTestActionListParams = {
	appName: string;
	hasPermission: ({ configPageName, entity, action }: HasPermissionArgument) => boolean;
};

export const makeActionList = (params: ABTestActionListParams) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: 'Edit',
				id: EAbExpActions.edit,
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.abTest,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].updateExperiment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show Bucket Details',
				id: EAbExpActions.buckets,
				isEnabled: () => {
					return true;
				}
			},
			{
				name: 'Show Version History',
				id: EAbExpActions.versionHistory,
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.abTest,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getVersionHistory,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show Version List',
				id: EAbExpActions.versionList,
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.abTest,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].getExperimentVersions,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Fix Users Bucket',
				id: EAbExpActions.fixUsersBucket,
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.abTest,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].fixUsersBucket,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Find User Bucket',
				id: EAbExpActions.findUserBucket,
				isEnabled: () => {
					return true;
				}
			}
		],
		addAction: {
			name: 'Add',
			id: EAbExpActions.add,
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.abTest,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.abTest].createExperiment,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
